import "isomorphic-fetch";
import { notifyError } from "@/utilities/notifyError";
import { loadingData, forbiddenData, errorData } from "../../ui/main/actions";
import { logOutUser } from "../../auth/sessions/actions";
import { SessionManager } from "../../../services/SessionManager";

export const SET_KOTS_APP_LIST = "SET_KOTS_APP_LIST";
export const SET_KOTS_APP_SECURITY_CENTER_ENABLED =
  "SET_KOTS_APP_SECURITY_CENTER_ENABLED";

// Orders app-list requests relative to targeted Security Center updates so an
// older response cannot restore the previous value for that field.
let kotsAppStateSequence = 0;

function nextKotsAppStateSequence() {
  kotsAppStateSequence += 1;
  return kotsAppStateSequence;
}

function setKotsAppList(kotsApps, requestSequence) {
  return {
    type: SET_KOTS_APP_LIST,
    payload: {
      kotsApps: kotsApps,
      requestSequence
    }
  };
}

export function setKotsAppSecurityCenterEnabled(appId, enabled) {
  return {
    type: SET_KOTS_APP_SECURITY_CENTER_ENABLED,
    payload: {
      appId,
      enabled,
      updateSequence: nextKotsAppStateSequence()
    }
  };
}

export function getKotsAppList(excludeChannels = true) {
  return async (dispatch, getState) => {
    const requestSequence = nextKotsAppStateSequence();
    dispatch(loadingData("kotsAppList", true));
    let response;
    try {
      const url = `${SessionManager.getApiEndpoint("3")}/apps?excludeChannels=${excludeChannels}`;
      response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: getState().auth.sessions.sessionData.accessToken,
          Accept: "application/json"
        },
        mode: "cors"
      });
      if (!response.ok) {
        if (response.status === 401) {
          dispatch(logOutUser());
        }
        if (response.status === 403) {
          dispatch(loadingData("kotsAppList", false));
          dispatch(forbiddenData("kotsAppList", true));
        }
        throw new Error(`Unexpected response status code ${response.status}`);
      }
      const body = await response.json();
      dispatch(setKotsAppList(body, requestSequence));
      dispatch(forbiddenData("kotsAppList", false));
      dispatch(loadingData("kotsAppList", false));
      dispatch(errorData("kotsAppList", false));
    } catch (error) {
      notifyError(error, { component: "kots_app", action: "getKotsAppList" });
      dispatch(loadingData("kotsAppList", false));
      dispatch(errorData("kotsAppList", true));
      return;
    }
  };
}
